import { z } from 'zod';

/** Core user shape returned by friends & family POST flows */
export const idmFriendFamilyUserBaseSchema = z.object({
	userId: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	ticketingId: z.string(),
	birthYear: z.number(),
	birthMonth: z.number(),
	birthDay: z.number(),
});
